import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import * as jsonPath from 'jsonpath/jsonpath';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConsumerConfigurationService 
{
  public cardTypes = {
    DEFAULT: 'default',
    HERO: 'hero',
    CARD: 'card',
    CALENDAR: 'calendar',
    CARDHORIZONTAL: 'card-horizontal',
    CARDPUBLICATION: 'card-publication',
    CARDMEETING: 'card-meeting',
    CARDFULL: 'card-full',
    CARDOVERLAY: 'card-overlay',
    ACCORDION: 'accordion'
  };

  public layersConfig: any;
  public review: boolean;

  public menuItems: Array<{ [key: string]: any }>;

  constructor(
    public translateService: TranslateService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) 
  {
    this.route.queryParams.subscribe(params => 
    { 
      if (params._review) {
        this.review = JSON.parse(params._review);
      }
    });
  }

  loadMapConfig():Promise<any>
  {
    return this.http.get('./assets/config/mapConfig.json').toPromise();
  }

  loadMenu(name):Promise<any>
  {
    return this.http.get('./assets/config/menu/' + name + '.json').toPromise();
  }

  getLanguageDependentAliases(config: any)
  {
    for(let key in config)
    {
      if (config[key].aliases) {
        for(let alias in config[key].aliases) {
          config[key].aliases[alias] = config[key].aliases[alias].replace('%defaultlang%',this.translateService.defaultLang);
          config[key].aliases[alias] = config[key].aliases[alias].replace('%currentlang%',this.translateService.currentLang);
        }
      }
    }

    return config;
  }

  getAlias(item, config)
  {
        if (config.defaultAlias) {
            return item.metadata.defaultAlias || item.metadata.alias[0];
        } 
        else 
        {
            let alias = '';

            for(let i=0; i<config.alias.values.length; i++)
            {
                let attrValues = jsonPath.query(item, '$.' + config.alias.values[i]);
                if (attrValues.length > 0) {
                    if (alias > '') {
                        alias = alias + (config.alias.separator ? config.alias.separator : '') + (isNaN(attrValues[0]) ? attrValues[0].toLowerCase() : attrValues[0]);
                    } else {
                        alias = alias + (isNaN(attrValues[0]) ? attrValues[0].toLowerCase() : attrValues[0]);
                    }
                }
            }
            
            return alias;
        }
  }
}
